export const COMPANY = {
  name: "Synergy Solar Inc.",
  shortName: "Synergy Solar",
  tagline: "Tricity's trusted rooftop solar partner",
  phone: "1800-891-2595",
  phoneHref: "tel:18008912595",
  whatsapp: "917814642907",
  email: "info@synergysolarenergy.com",
  address: "Plot No. 649, Industrial Area Phase IX, Mohali, Punjab 160062",
  region: "Chandigarh, Punjab, Haryana & New Delhi",
  mapUrl: "https://maps.app.goo.gl/1vPUw3ZN2J8wupve7",
  mapEmbed: "https://www.google.com/maps?q=Plot+No.+649,+Industrial+Area+Phase+IX,+Mohali,+Punjab+160062&output=embed",
};

const P = (process.env.PUBLIC_URL || "") + "/proj/";

// Real Synergy Solar project photos (optimized WebP, served locally)
export const PHOTOS = {
  schoolChd300: P + "school300.webp",
  deraBassi400: P + "derabassi400.webp",
  residentialTower250: P + "tower250.webp",
  baddi200: P + "baddi200.webp",
  punjab500: P + "punjab500.webp",
  crewMohali150: P + "crew150.webp",
  carportKharar100: P + "carport100.webp",
  resChd20: P + "res20.webp",
  resMohali10: P + "res10.webp",
  resChd5: P + "res5.webp",
  embassy1: P + "embassy1.webp",
  embassy2: P + "embassy2.webp",
  embassyConstruction: P + "embassy_construction.webp",
  baddi600: P + "baddi600.webp",
};

export const LOGOS = {
  royalBhutanese: P + "logo-royal-bhutanese.webp",
};

export const IMAGES = {
  heroBg: PHOTOS.punjab500,
  resIndia: PHOTOS.residentialTower250,
  resTile: PHOTOS.deraBassi400,
  comm1: PHOTOS.baddi200,
  comm2: PHOTOS.punjab500,
  comm3: PHOTOS.schoolChd300,
  worker1: PHOTOS.crewMohali150,
  worker2: PHOTOS.resChd20,
  worker3: PHOTOS.resMohali10,
  family: PHOTOS.resChd5,
};

export const CITIES = [
  { slug: "chandigarh", name: "Chandigarh", state: "Chandigarh UT", sunHours: "5.8", installs: "420+", avgSaving: "82,000", blurb: "The City Beautiful runs on sunshine 300+ days a year — the ideal canvas for rooftop solar.", subsidy: "PM Surya Ghar subsidy up to ₹78,000 + Chandigarh Renewable Energy (CREST) net-metering.", image: PHOTOS.schoolChd300 },
  { slug: "mohali", name: "Mohali", state: "Punjab", sunHours: "5.7", installs: "310+", avgSaving: "76,000", blurb: "SAS Nagar's independent homes and IT parks are switching to clean, self-generated power.", subsidy: "PSPCL net-metering + PM Surya Ghar central subsidy up to ₹78,000.", image: PHOTOS.residentialTower250 },
  { slug: "panchkula", name: "Panchkula", state: "Haryana", sunHours: "5.8", installs: "280+", avgSaving: "79,000", blurb: "Panchkula's sectors enjoy excellent irradiance — perfect for high-yield rooftop systems.", subsidy: "UHBVN net-metering + PM Surya Ghar subsidy up to ₹78,000.", image: IMAGES.comm2 },
  { slug: "baddi", name: "Baddi", state: "Himachal Pradesh", sunHours: "5.5", installs: "160+", avgSaving: "1,90,000", blurb: "India's industrial hub — commercial rooftops here slash sky-high factory power bills.", subsidy: "HPSEBL net-metering + accelerated depreciation benefits for businesses.", image: IMAGES.comm1 },
  { slug: "dera-bassi", name: "Dera Bassi", state: "Punjab", sunHours: "5.7", installs: "120+", avgSaving: "74,000", blurb: "Growing homes and mills along the highway are cutting costs with rooftop solar.", subsidy: "PSPCL net-metering + PM Surya Ghar subsidy up to ₹78,000.", image: IMAGES.resTile },
  { slug: "kurali", name: "Kurali", state: "Punjab", sunHours: "5.6", installs: "90+", avgSaving: "71,000", blurb: "Kurali households are future-proofing against rising tariffs with clean rooftop energy.", subsidy: "PSPCL net-metering + PM Surya Ghar subsidy up to ₹78,000.", image: IMAGES.resIndia },
  { slug: "parwanoo", name: "Parwanoo", state: "Himachal Pradesh", sunHours: "5.5", installs: "70+", avgSaving: "1,60,000", blurb: "Hillside industry and resorts in Parwanoo generate their own power year-round.", subsidy: "HPSEBL net-metering + commercial depreciation benefits.", image: IMAGES.comm3 },
  { slug: "kharar", name: "Kharar", state: "Punjab", sunHours: "5.7", installs: "140+", avgSaving: "73,000", blurb: "Kharar's fast-growing residential belt is going solar with zero-down financing.", subsidy: "PSPCL net-metering + PM Surya Ghar subsidy up to ₹78,000.", image: IMAGES.resTile },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);

export const MANIFESTO = [
  { n: "01", title: "Free site assessment", body: "Our engineers study your roof, shading and consumption, then design a system sized precisely to your bill — no guesswork." },
  { n: "02", title: "Transparent proposal", body: "You get a clear quote with Tier-1 panels, subsidy calculations, savings projections and payback — nothing hidden." },
  { n: "03", title: "Turnkey installation", body: "Certified crews handle structure, wiring, inverter and safety in days, with net-metering paperwork done for you." },
  { n: "04", title: "25 years of sunshine", body: "Monitor generation from your phone. We back every system with performance warranties and lifetime support." },
];

export const FAQS = [
  { q: "How much can I save with rooftop solar?", a: "Most Tricity homes offset 70-95% of their electricity bill. With current tariffs, a typical 3-5 kW system pays for itself in 3-5 years and then delivers 20+ years of near-free power." },
  { q: "What subsidy can I get?", a: "Under the PM Surya Ghar: Muft Bijli Yojana, residential systems qualify for a central subsidy of up to ₹78,000, plus net-metering with your state DISCOM. We handle all the paperwork." },
  { q: "Do panels work during Tricity summers and monsoon?", a: "Yes. Panels generate all year; peak output is in clear months but they still produce on cloudy days. The Tricity region enjoys 300+ sunny days annually — ideal for solar." },
  { q: "What warranty do you provide?", a: "We install Tier-1 panels with a 25-year performance warranty, 5-10 year product warranties, and comprehensive workmanship coverage backed by Synergy Solar." },
  { q: "Is there a zero-down financing option?", a: "Yes. We offer easy EMI and zero-down financing so you can start saving from month one without a large upfront payment." },
];

export const STATS = [
  { value: "2,000+", label: "Installations across Tricity" },
  { value: "15 MW+", label: "Clean capacity commissioned" },
  { value: "25 yr", label: "Performance warranty" },
  { value: "4.9/5", label: "Average customer rating" },
];

export const TESTIMONIALS = [
  { name: "Tajeshwar Singh Sullar", city: "Chandigarh", google: true, quote: "I contacted Synergy Solar for a solar plant at my house in Chandigarh five years ago, and it's been flawless ever since. The plant still works perfectly, generates good units, and I almost get a zero bill. Their customer service is top-notch — highly recommended." },
  { name: "Ranjit Kohli", city: "Chandigarh", google: true, quote: "Our experience through the entire process — installation, commissioning and refund of subsidy — has been very satisfactory. Synergy's responses were always very timely and quick." },
  { name: "Hardeep Singh Dhiman", city: "Mohali", google: false, quote: "Synergy Solar installed our rooftop system, arrived on time and completed the job neatly. Excellent service from start to finish — great workmanship and friendly staff. Highly recommended!" },
  { name: "Saurabh Garg", city: "Baddi", google: false, quote: "The solar power plant installed at my factory in Baddi is working satisfactorily. We are very happy with their prompt services." },
];

import { Home as HomeIcon, Building2, Users, Wrench, Sun as SunIcon, BatteryCharging } from "lucide-react";

export const SERVICES = [
  {
    slug: "residential",
    icon: HomeIcon,
    title: "Residential Rooftop Solar",
    tagline: "For homes & villas",
    short: "Right-sized 1–10 kW systems that wipe out your home electricity bill and pay for themselves in 3–5 years.",
    points: ["On-grid & hybrid systems", "PM Surya Ghar subsidy up to ₹78,000", "Net-metering handled end-to-end", "Mobile app generation monitoring"],
    image: PHOTOS.resChd20,
  },
  {
    slug: "commercial",
    icon: Building2,
    title: "Commercial & Industrial",
    tagline: "For businesses & factories",
    short: "High-yield rooftop and ground-mount plants that slash operating costs and unlock accelerated depreciation.",
    points: ["10 kW – 1 MW+ capacity", "CAPEX & OPEX / PPA models", "Accelerated depreciation benefits", "SCADA plant monitoring"],
    image: IMAGES.comm1,
  },
  {
    slug: "housing-societies",
    icon: Users,
    title: "Housing Societies",
    tagline: "For RWAs & apartments",
    short: "Common-area and shared rooftop solar that cuts maintenance charges for every resident in the society.",
    points: ["Common-area load offset", "Transparent per-flat savings", "Zero-hassle approvals", "Dedicated society manager"],
    image: PHOTOS.residentialTower250,
  },
  {
    slug: "maintenance",
    icon: Wrench,
    title: "O&M & AMC",
    tagline: "Care for existing systems",
    short: "Comprehensive operation & maintenance to keep any solar plant generating at peak efficiency for decades.",
    points: ["Panel cleaning & inspection", "Inverter health checks", "Performance reporting", "Rapid fault resolution"],
    image: PHOTOS.crewMohali150,
  },
  {
    slug: "solar-water-heating",
    icon: SunIcon,
    title: "Solar Water Heating",
    tagline: "Hot water, free from the sun",
    short: "Evacuated-tube and flat-plate solar water heaters for homes, hotels and hostels across the Tricity.",
    points: ["100–1000 LPD systems", "Hard-water compatible", "Winter-ready performance", "5-year system warranty"],
    image: PHOTOS.resMohali10,
  },
  {
    slug: "battery-storage",
    icon: BatteryCharging,
    title: "Battery & Backup",
    tagline: "Power even when the grid fails",
    short: "Hybrid inverters and lithium battery storage so your home or business keeps running through outages.",
    points: ["Lithium & tubular options", "Seamless backup switchover", "Solar + storage hybrid design", "Scalable capacity"],
    image: PHOTOS.resChd5,
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);

export const VALUES = [
  { title: "Engineering-led", body: "Every system is designed by qualified solar engineers around your roof, shading and actual consumption." },
  { title: "Tier-1 only", body: "We install bankable, top-tier panels and inverters — never the cheapest components that fail early." },
  { title: "Transparent pricing", body: "Clear quotes with subsidy, savings and payback laid out. No hidden charges, ever." },
  { title: "Lifetime support", body: "Local Tricity crews and a 25-year performance warranty mean help is always around the corner." },
];

export const PROJECTS = [
  { title: "180 kW Royal Bhutanese Embassy", city: "New Delhi", type: "Commercial", image: PHOTOS.embassy1, stat: "180 kW" },
  { title: "5 kW home rooftop", city: "Chandigarh", type: "Residential", image: PHOTOS.resChd5, stat: "5 kW" },
  { title: "10 kW home rooftop", city: "Mohali", type: "Residential", image: PHOTOS.resMohali10, stat: "10 kW" },
  { title: "20 kW residence", city: "Chandigarh", type: "Residential", image: PHOTOS.resChd20, stat: "20 kW" },
  { title: "100 kW solar carport", city: "Kharar", type: "Commercial", image: PHOTOS.carportKharar100, stat: "100 kW" },
  { title: "150 kW industrial shed", city: "Mohali", type: "Industrial", image: PHOTOS.crewMohali150, stat: "150 kW" },
  { title: "200 kW industrial shed", city: "Baddi", type: "Industrial", image: PHOTOS.baddi200, stat: "200 kW" },
  { title: "250 kW residential towers", city: "Mohali", type: "Housing Society", image: PHOTOS.residentialTower250, stat: "250 kW" },
  { title: "300 kW school rooftop", city: "Chandigarh", type: "Commercial", image: PHOTOS.schoolChd300, stat: "300 kW" },
  { title: "400 kW factory shed", city: "Dera Bassi", type: "Industrial", image: PHOTOS.deraBassi400, stat: "400 kW" },
  { title: "500 kW industrial roof", city: "Punjab", type: "Industrial", image: PHOTOS.punjab500, stat: "500 kW" },
  { title: "600 kW industrial rooftop", city: "Baddi", type: "Industrial", image: PHOTOS.baddi600, stat: "600 kW" },
];

export const MILESTONES = [
  { year: "2011", text: "Founded in Chandigarh with a mission to make clean energy simple." },
  { year: "2016", text: "Crossed 500 rooftop installations across the Tricity region." },
  { year: "2020", text: "Expanded into commercial & industrial solar and Himachal towns." },
  { year: "2026", text: "2,000+ installs and 15 MW+ of clean capacity commissioned." },
];

export const MISSION = "To deliver innovative and reliable solar solutions that empower clients to achieve energy independence while creating a cleaner and greener tomorrow.";
export const VISION = "To be a trusted leader in solar energy by setting benchmarks in quality, innovation and customer satisfaction for a sustainable future.";

// Organizations served (from company brochure)
export const CLIENTS = [
  { name: "Royal Bhutanese Embassy", logo: P + "logo-royal-bhutanese.webp" },
  { name: "IFFCO", logo: P + "logo-iffco.webp" },
  { name: "PGIMER Chandigarh", logo: P + "logo-pgi.webp" },
  { name: "Jubilee", logo: P + "logo-jubilee.webp" },
  { name: "PEDA", logo: P + "logo-peda.webp" },
  { name: "Marbella Grand", logo: P + "logo-marbella.webp" },
  { name: "Godrej", logo: P + "logo-godrej.webp" },
  { name: "GILLCO", logo: P + "logo-gillco.webp" },
  { name: "ICICI Foundation", logo: P + "logo-icici.webp" },
  { name: "DSM", logo: P + "logo-dsm.webp" },
  { name: "HAREDA", logo: P + "logo-hareda.webp" },
  { name: "Suez", logo: P + "logo-suez.webp" },
  { name: "Alkem", logo: P + "logo-alkem.webp" },
  { name: "BPTP", logo: P + "logo-bptp.webp" },
  { name: "CREST Chandigarh", logo: P + "logo-crest.webp" },
  { name: "Puri Constructions", logo: P + "logo-puri.webp" },
  { name: "Veolia", logo: P + "logo-veolia.webp" },
  { name: "Central Park", logo: P + "logo-centralpark.webp" },
  { name: "Affinity Greens", logo: P + "logo-affinity.webp" },
  { name: "VRS Communities", logo: P + "logo-vrs.webp" },
  { name: "WABAG", logo: P + "logo-wabag.webp" },
  { name: "Shishu Niketan-22", logo: P + "logo-shishu.webp" },
  { name: "Seigneur Medipack", logo: P + "logo-seigneur.webp" },
];
